import * as types from '../mutation-types';


const state = {
  environment: process.env.NODE_ENV,
  production: process.env.NODE_ENV === 'production',
  production_log_level: 'info',
  development_log_level: 'debug',
  log_levels: ['debug', 'info', 'warn', 'error'],
}


const helpers = {
  canLog(state, level) {
    if (state.production) {
      return state.log_levels.indexOf(level) >= state.log_levels.indexOf(state.production_log_level);
    } else {
      return state.log_levels.indexOf(level) >= state.log_levels.indexOf(state.development_log_level);
    }
  }
}


const mutations = {
  [types.SET_PRODUCTION_LOG_LEVEL](state, level) {
    if (state.log_levels.includes(level)) {
      state.production_log_level = level;
    }
  },
  [types.SET_DEVELOPMENT_LOG_LEVEL](state, level) {
    if (state.log_levels.includes(level)) {
      state.development_log_level = level;
    }
  },
}


const actions = {
  logAction({state}, {level, args}) {
    if (helpers.canLog(state, level)) {
      console[level](...args);
    }
  }
}



export default {
  state,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/logging.js